import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import SnapshotModal from "@/components/SnapshotModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SnapshotBuilder',
  props: {
    demoCohortId: {}
  },
  setup(__props: any) {


const showModal = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "btn-bottom-right-float btn btn-burg",
      type: "button",
      href: "#snapshots",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true))
    }, " Demo Snapshots "),
    (showModal.value)
      ? (_openBlock(), _createBlock(SnapshotModal, {
          key: 0,
          modelValue: showModal.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showModal).value = $event)),
          "demo-cohort-id": _ctx.demoCohortId
        }, null, 8, ["modelValue", "demo-cohort-id"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})